import React, { useState } from 'react';
import { connect } from 'react-redux';
import Textarea from 'react-textarea-autosize';

import mapActionsToDispatchToProps from 'utils/core/mapActionsToDispatchToProps.util';

import { changeBookingNotes } from 'booking/actions';

const BookingNotes = ({ notes, changeBookingNotes }) => {
  const [currentNotes, setCurrentNotes] = useState(notes || '');

  const handleBlur = (ev) => {
    changeBookingNotes(ev.target.value);
  };

  const handleChange = (ev) => {
    setCurrentNotes(ev.target.value);
  };

  return (
    <div data-bem="BookingNotes--shown">
      <Textarea style={{ resize: 'vertical' }} className="note" onBlur={handleBlur} onChange={handleChange} value={currentNotes} />
    </div>
  );
};

const BookingNotesHoc = connect(
  (state) => ({
    notes: state?.booking?.notes,
  }),
  mapActionsToDispatchToProps({
    changeBookingNotes,
  }),
)(BookingNotes);

export default BookingNotesHoc;
